/** nextjs writes these flags as JSON booleans, muse writes strings — both tiers read both. */
export const normalizeFlag = (stored: unknown): boolean => stored === true || stored === 'true'
